import { render } from "./Top5Influencers.vue?vue&type=template&id=f92cbd34&scoped=true"
import script from "./Top5Influencers.vue?vue&type=script&lang=js"
export * from "./Top5Influencers.vue?vue&type=script&lang=js"

import "./Top5Influencers.vue?vue&type=style&index=0&id=f92cbd34&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f92cbd34"]])

export default __exports__